import Vue from "vue";
import Vuex from "vuex";
import getters from "./getters";
import mutations from "./mutations";
import actions from "./actions";
import { availableLanguages } from "../configs/global";

Vue.use(Vuex);
const store = new Vuex.Store({
  state: {
    authCookie: "",
    languageCookie: "",
    loading: false,
    authorized: false,
    languages: availableLanguages,
    languageSelected: availableLanguages[0],
    member: "",
    accounts: "",
    accountSelected: "",
    fees: "",
    feeRedeem: "",
    feePurchase: "",
    currencies: "",
    bluAccount: "",
    btcAccount: "",
    ethAccount: "",
    realtAccount: "",
    joinPool: false,
    bluValue: "",
    usdtAccount: "",
    btcValue: "",
    ethValue: "",
    xemValue: "",
    zarValue: "",
    eurValue: "",
    gbpValue: "",
    chfValue: "",
    cnyValue: "",
    hkdValue: "",
    rasValue: "",
    cadValue: "",
    audValue: "",
    usdtValue: "",
    assetList: "",
    fundValueBtc: "",
    minimumInvestiment: 250
  },
  getters,
  mutations,
  actions
});

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js